import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/vendoo';

export default function Example() {
  return (
    <>
      <Head>
        <title>Vendoo - Is Vendoo Worth It For You? (2021) | OneShop Blog</title>
        <meta
          name='description'
          content="Vendoo allows users to post on multiple marketplaces. Find out if it's worth it for you!"
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/vendoo' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/vendoo' />
        <meta property='og:title' content='Vendoo - Is Vendoo Worth It For You? (2021) | OneShop Blog' />
        <meta
          property='og:description'
          content="Vendoo allows users to post on multiple marketplaces. Find out if it's worth it for you!"
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-11T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-11T00:00:00.000Z' />
        <meta property='article:tag' content='Vendoo' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
